import styled from "@emotion/styled";
const withoutOutline = (Component, hasMaxWidth) => styled(Component)`
  &:focus {
    outline: 2px solid transparent;
    outline-offset: 4px;
  }
  ${hasMaxWidth ? "max-width: 100%;" : null}
`;
export {
  withoutOutline as w
};
//# sourceMappingURL=WithoutOutline-_MwFlIvo.js.map
